// @ts-strict-ignore
import { Element, Editor, Text } from 'slate';
import { stripTags } from 'underscore.string';
import { ImageElement } from 'src/components/textEditor/customTypes';

type EditorDataReturnProps = {
  text: string,
  mentionedUserIds: number[],
  image?: { file?: File, url?: string, hash?: string, description?: string },
}

export const getEditorData = (editor: Editor): EditorDataReturnProps => {
  const text = serialise(editor);
  const mentionedUserIds = getMentionsArray(editor);
  const postImage = editor.children.find((subNode: Element) => subNode.type === 'image');
  let image;
  if (postImage) {
    const { file, hash, url, description } = postImage as ImageElement;
    image = { file, url, hash, description };
  }

  return { text, mentionedUserIds, image };
};

const getMentionsArray = (editor) => {
  const mentionedIds = editor.children.reduce((ids, block) => {
    const blockMentions = block.children.filter(({ type }) => type === 'mention');
    const newUserIds = blockMentions.map(mention => mention.type === 'mention' && mention.mentionedUser.userId);
    return ids.concat(newUserIds);
  }, []);

  return mentionedIds;
};

export const serialise = node => {
  if (Text.isText(node)) {
    let string = stripTags(node.text);
    if (node.bold) {
      string = `[b]${string}[/b]`;
    }
    if (node.italic) {
      string = `[i]${string}[/i]`;
    }
    if (node.underline) {
      string = `[u]${string}[/u]`;
    }
    return string;
  }

  const children = node.children && node.children.map(subNode => serialise(subNode)).join('');

  switch (node.type) {
    case 'image':
      return '';
    case 'mention':
      return `@[${node.mentionedUser?.userId}]`;
    case 'paragraph':
      return `${children}\n\n`;
    // case 'link': // not in yet
    //   return `<a href="${encodeURI(node.url)}">${children}</a>`;
    default:
      return children;
  }
};
